type HostMapping = Record<string, string>;

function getApiHostsMapping(): HostMapping {
  if (!process.env.REACT_APP_API_HOSTS) return {};

  try {
    return JSON.parse(process.env.REACT_APP_API_HOSTS);
  } catch {
    throw new Error(
      `Failed to parse REACT_APP_API_HOSTS: should be JSON mapping of hostname to API URL, e.g. '{"10.0.4.16":"http://10.0.4.16:8081/api/1/"}, but received: ${process.env.REACT_APP_API_HOSTS}`
    );
  }
}

function resolveApiUrl(): string {
  const mapping = getApiHostsMapping();
  const { hostname } = window.location;

  if (mapping[hostname]) {
    return mapping[hostname];
  }

  const legacyUrl = process.env.REACT_APP_BASE_API_URL;
  if (legacyUrl) return legacyUrl;

  throw new Error(
    `Unable to resolve API URL mapping for hostname, check REACT_APP_API_HOSTS and REACT_APP_BASE_API_URL: ${hostname}`
  );
}

let _baseApiUrl: string | null = null;

export function getBaseApiUrl(): string {
  if (!_baseApiUrl) _baseApiUrl = resolveApiUrl();
  return _baseApiUrl;
}
